import React, { useEffect, useState, useCallback, useRef } from 'react';
import API, { resolvePhoto } from '../utils/api';
import { useSiteSettings } from '../context/SiteSettingsContext';
import './TopBanner.css';

function BannerSlide({ banner }) {
  if (banner.type === 'image' && banner.imageUrl) {
    const img = (
      <img
        src={resolvePhoto(banner.imageUrl)}
        alt={banner.imageAlt || 'Iklan'}
        className="top-banner-img"
      />
    );
    return banner.linkUrl
      ? <a href={banner.linkUrl} target="_blank" rel="noopener noreferrer" className="top-banner-img-link">{img}</a>
      : img;
  }

  if (banner.type === 'text' && banner.text) {
    return (
      <div
        className="top-banner-container top-banner-container--text"
        style={{ background: banner.bgColor || '#e85d04' }}
      >
        <span className="top-banner-text" style={{ color: banner.textColor || '#fff' }}>
          {banner.text}
        </span>
        {banner.linkUrl && banner.linkLabel && (
          <a
            href={banner.linkUrl} target="_blank" rel="noopener noreferrer"
            className="top-banner-text-link"
            style={{ color: banner.textColor || '#fff' }}
          >
            {banner.linkLabel} →
          </a>
        )}
      </div>
    );
  }

  return null;
}

export default function TopBanner() {
  const { settings } = useSiteSettings();
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!settings.featureAds) { setBanners([]); return; }
    API.get('/banner').then(r => setBanners(r.data.banners || [])).catch(() => {});
  }, [settings.featureAds]);

  const next = useCallback(() => {
    setIdx(i => (i + 1) % banners.length);
  }, [banners.length]);

  const prev = useCallback(() => {
    setIdx(i => (i - 1 + banners.length) % banners.length);
  }, [banners.length]);

  // Auto-slide setiap 5 detik
  useEffect(() => {
    if (banners.length <= 1 || paused) return;
    timerRef.current = setInterval(next, 5000);
    return () => clearInterval(timerRef.current);
  }, [banners.length, paused, next]);

  if (!settings.featureAds) return null;
  if (banners.length === 0) return null;

  const current = banners[idx];
  const isImage = current.type === 'image' && current.imageUrl;
  const isText  = current.type === 'text'  && current.text;
  if (!isImage && !isText) return null;

  return (
    <div
      className={`top-banner-wrap${isText ? ' top-banner-wrap--text' : ''}`}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* Label iklan */}
      {!isText && (
        <div className="top-banner-label-row">
          <span className="top-banner-label">Iklan</span>
        </div>
      )}

      {/* Slide */}
      <div className="top-banner-container">
        <BannerSlide banner={current} />
      </div>

      {/* Navigasi — hanya jika lebih dari 1 slide */}
      {banners.length > 1 && (
        <div className="top-banner-nav">
          <button className="top-banner-arrow" onClick={prev} aria-label="Sebelumnya">‹</button>
          <div className="top-banner-dots">
            {banners.map((_, i) => (
              <button
                key={i}
                className={`top-banner-dot${i === idx ? ' active' : ''}`}
                onClick={() => setIdx(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
          <button className="top-banner-arrow" onClick={next} aria-label="Berikutnya">›</button>
        </div>
      )}
    </div>
  );
}
